import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';

export default class Welcome extends SceneBase {
  constructor() {
    super({ key: KEYS.Welcome, active: false });
  }

  create() {
    super.create();
    this.game.hud.setState('WELCOME');
    this.setBackground('background_welcome');
    this.add.image(840, 220, 'game_logo');
    this.game.soundController.playMusic('music');
  }

  shutdown() {
    super.shutdown();
  }
}
